import svg4everybody from 'svg4everybody/dist/svg4everybody';

var self = {};

self.initialise = function () {
  svg4everybody();
}

module.exports = self;



// WEBPACK FOOTER //
// ./sitefiles/scripts/global/rebuild-components/init-svg4everybody.js